export default __webpack_public_path__ + "media/images/icons_fc/clientsblanc-cbbcac29a31652694aca136af68670c6.png";